module.exports = __webpack_public_path__ + "static/media/tog.3b66a34b.jpg";